import React from 'react';
import './confirm-profile.scss';
import SchoolProfile from '../../school/add-school/add-school'
import StaffProfile from './staff-profile/staff-profile'
import SessionCache from '../../routes/session-cache';
import { Modal, ModalBody } from "reactstrap";
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'

class ConfirmProfile extends React.Component {
    state = {
    }

    constructor() {
        super()
        this.getStaffInfo()
    }

    getStaffInfo() {
        let user = SessionCache.getUser()
        let isAdmin = user.types.some(item => item.type == "ADMIN")
        if (isAdmin) {
            this.state.isAdmin = isAdmin
            this.state.schoolProfileConfirmed = user.schoolInfo?.isConfirmed
            this.state.userProfileUpdated = user.profileUpdated
        } else {
            this.state.userProfileUpdated = user.profileUpdated

        }
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onSave = () => {
        this.showToaster("success", "Profile Updated");

        let user = SessionCache.getUser()
        user.schoolInfo.isConfirmed = true
        SessionCache.setUser(user)
        this.props.onSave && this.props.onSave()
    }

    render() {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.props.onClose} size={'lg'}>

                <ModalBody >
                    <div className="confirm-profile-dashboard">
                        <div>
                            <div className="abs-image">
                                <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                            </div>

                            <div className="pt-4 my-auto">
                                <span className="step-title">{this.props.step}</span>
                                <span className="float-right">
                                    <img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.props.onClose} />
                                </span>
                            </div>

                        </div>
                        {
                            this.state.isAdmin ?
                                <SchoolProfile disableBack={true} headerTitle="Please confirm your details" onSave={this.onSave} />
                                :
                                <StaffProfile headerTitle="Please confirm your details" onSave={this.onSave} />
                        }

                    </div >
                </ModalBody>
            </Modal>
        );
    }
}

export default ConfirmProfile;